
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";
import {Poker2CheatsPanel} from "../../../view/panels/cheats/Poker2CheatsPanel";

import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("TJNCommand");

export class TJNCommand extends Poker2Command {
    protected get cmdId(): string {
        return "tjn";
    }
    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            try {
                var paramObj: any = JSON.parse(params[1]);

                if(!Poker2CheatsPanel.IS_CHEATING) {
                    this.layoutManager.state = 10;
                }

                //type 0: Normaler Tisch
                Poker2Model.onTableData.parse_TJN(paramObj);
            } catch (er) {
                logger.error(er.message);
                if(this.layoutManager.state != 11) {
                    this.layoutManager.state = 11;
                }
            }
            Poker2CheatsPanel.IS_CHEATING = false;
            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
